import { render, staticRenderFns } from "./select-organization.vue?vue&type=template&id=07c6d91e&"
import script from "./select-organization.vue?vue&type=script&lang=js&"
export * from "./select-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports